<template>
    <div class="group-box">
        <span
                v-for="(item,index) in groupList"
                :key="index"
                @click="changeGroup(item,index)"
                :class="currGroup == index?'active':''"
        >{{item.name}}</span>
    </div>
</template>

<script>
    export default {
        name: "MoveScene",
        props:{
            groupList:{
                type:Array,
                default: ()=> []
            },
            currId:{
                type: String,
                default: ''
            }
        },
        data(){
            return{
                currGroup: -1
            }
        },
        mounted() {
            this.groupList.forEach((obj,index)=>{
                obj.scenes.forEach(s => {
                    if(s == this.currId){
                        this.currGroup = index
                        return
                    }
                })
            })
        },
        methods:{
            changeGroup(item,index){
                this.currGroup = index
                this.$emit('move',item)
            }
        }
    }
</script>

<style lang="less" scoped>
    .group-box{
        display: flex;
        flex-wrap: wrap;
        span{
            display: inline-block;
            padding: 5px 12px;
            border-radius: 5px;
            background-color: #dedede;
            margin: 0 8px 16px 8px;
            flex-shrink: 0;
            cursor: pointer;
            &.active{
                background-color: #015c61;
                color: #ffffff;
            }
        }
    }
</style>
